import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import { VcsIntegrationUser } from "types/generated";

const IntegrationsVcsUsedByTableDropdownCell = ({
  ...cellProps
}: TableSimpleCellProps<VcsIntegrationUser>) => {
  return <TableSimpleCell {...cellProps} />;
};

export default IntegrationsVcsUsedByTableDropdownCell;
